import styled, { css } from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Mixins } from 'planoplan-ui-kit/core/mixins';

export const buttonLinkCss = css`
  ${Mixins.transition('color')};
  border: none;
  background: transparent;
  font-size: inherit;
  color: ${(p) => (p.disabled ? Colors.solitude : Colors.planoplan_blue)};
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: normal;
  margin-right: 7px;
  cursor: pointer;
  pointer-events: ${(p) => (p.disabled ? 'none' : 'auto')};
  text-decoration: none;
  padding: 4px 2px;
  vertical-align: middle;

  &:last-child {
    margin-right: 0;
  }

  &:disabled {
    pointer-events: none;
    cursor: default;
    color: ${Colors.solitude};
  }

  &:hover {
    color: ${(p) => (p.disabled ? Colors.solitude : Colors.electric_blue)};
  }
`;
export const ButtonLink = styled.a`
  ${buttonLinkCss};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
